module.exports = __webpack_public_path__ + "static/media/otros_servicios.4cef4eba.jpg";